export const ADSWIZZ_SYNCHROBOX_SCRIPT = 'https://synchrobox.adswizz.com/register2.php';
export const DISCORD_ADSWIZZ_SYNCHROBOX_SCRIPT = '/adswizz/synchrobox/register2.php';
export const ADSWIZZ_SYNCHROCLIENT_SCRIPT = 'https://delivery-cdn-cf.adswizz.com/adswizz/js/SynchroClient2.js';
export const DISCORD_ADSWIZZ_SYNCHROCLIENT_SCRIPT = '/adswizz/delivery-cdn-cf/adswizz/js/SynchroClient2.js';
export const ADSWIZZ_GDPR_TCFV2_TCSTRING_PARAMETER = 'aw_0_req.userConsentV2';
export const ADSWIZZ_GDPR_PARAMETER = 'aw_0_req.gdpr';
export const ADSWIZZ_LOTAME_PARAMETER = 'aw_0_1st.lotamesegments';
export const ADSWIZZ_REQUEST_URL = 'https://tunein.deliveryengine.adswizz.com/vast/4.0/request/alias/VAST_Preroll';
export const DFP_GDPR_NON_PERSONALIZED_ADS_PARAMETER = 'npa';
export const US_RESTRICTED_DATA_PROCESSING_ADS_PARAMETER = 'rdp';
export const PAL_SCRIPT = '//imasdk.googleapis.com/pal/sdkloader/pal.js';
export const DISCORD_PAL_SCRIPT = '/googleapis/imasdk/pal/sdkloader/pal.js';
export const PAL_SCRIPT_ID = 'PAL_SCRIPT_ID';
export const IMA_PLAYER_SCRIPT = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
export const DISCORD_IMA_PLAYER_SCRIPT = '/googleapis/imasdk/js/sdkloader/ima3.js';
export const IMA_VIDEO_PLAYER_ID = 'imaPlayer';
export const IMA_PLAYER_SCRIPT_ID = 'imaSdkScript';
export const NO_FILL_LABEL = 'no fill';
export const PREROLL_SLOT_NAME = 'preroll';
export const MIDROLL_SLOT_NAME = 'midroll';
export const VIDEO_MEDIUM = 'video';
export const partialGamVideoPrerollSlot = {
    adProvider: 'dfp',
    medium: VIDEO_MEDIUM,
    isVideoOnly: true,
};
